
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { StickyChilli_ResponsivePIXIApp } from "../StickyChilli/game_ResponsivePIXIApp";


    export class StickyChilliLink_ResponsivePIXIApp extends StickyChilli_ResponsivePIXIApp {

        constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "StickyChilliLink") {
            super(multigameParams, initData, gameName);
        }

    }